import { useEffect, useState } from 'react'
import { useTranslate } from '@/utils/translate/translate-client'
import { OptionGroup } from '../../components/OptionGroup'
import { useTorchApplication } from '../../components/TorchApplicationContext'

type Props = {
  disabled?: boolean
  isThumbnailUploaded?: boolean
}

export const ThumbnailUploadCheckboxes = ({ disabled, isThumbnailUploaded = false }: Props) => {
  const { t } = useTranslate('guild-create')
  const { data, updateData } = useTorchApplication()
  const [value, setValue] = useState<string[]>(() => (isThumbnailUploaded ? ['text'] : []))

  const thumbnailAcknowledgement = data?.uploadAcknowledgements?.includes('thumbnail')

  useEffect(() => {
    if (thumbnailAcknowledgement) {
      setValue(['text'])
    }
  }, [thumbnailAcknowledgement])

  useEffect(() => {
    if (disabled) return

    if (!thumbnailAcknowledgement && value.length === 1) {
      updateData({ uploadAcknowledgements: (data?.uploadAcknowledgements || []).concat(['thumbnail']) })
    } else if (thumbnailAcknowledgement && value.length < 1) {
      updateData({ uploadAcknowledgements: (data?.uploadAcknowledgements || []).filter((ack) => ack !== 'thumbnail') })
    }
  }, [value, updateData, thumbnailAcknowledgement, data?.uploadAcknowledgements, disabled])

  const options = [
    {
      label: t('thumbnailHasNoText', 'The thumbnail has no text other than the name of the video (which is optional).'),
      value: 'text',
    },
  ]

  return (
    <OptionGroup
      hasAsset={isThumbnailUploaded}
      value={value}
      options={options}
      onChange={setValue}
      label={t(
        'iAcknowledgeThatThisThumbnailMeetsTheFollowingCriteria',
        'I acknowledge that this thumbnail meets the following criteria:',
      )}
      name="uploadCheckboxes"
      wrap={false}
      outline={false}
      disabled={disabled}
    />
  )
}
